"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetMarginMode = exports.FuturesCashflowSubType = exports.FuturesCashflowType = exports.FuturesRequestStatus = exports.OrderChangedNotifyType = exports.FutureOrderMode = exports.OrderPositionMode = exports.QueryOrderStatus = exports.OrderStatus = exports.OrderState = exports.OrderDirect = exports.InvestSymbolSide = exports.FutureWorkingType = exports.FuturePositionSide = exports.FutureMarginAction = exports.FutureTimeInForce = exports.FutureOrderMarginType = exports.FutureMarginType = exports.TriggerOrderState = exports.OrderSourceType = exports.CustomOrderType = exports.UIOpenCloseMode = exports.FuturesOrderTypeUI = exports.ContractStatus = exports.ContractType = exports.CustomOrderSide = void 0;
/** 订单方向 buy sell */
var CustomOrderSide;
(function (CustomOrderSide) {
    CustomOrderSide["BUY"] = "buy";
    CustomOrderSide["SELL"] = "sell";
})(CustomOrderSide = exports.CustomOrderSide || (exports.CustomOrderSide = {}));
/**
 * 合约类型
 */
var ContractType;
(function (ContractType) {
    /**
     * 永续合约
     */
    ContractType["PERPETUAL"] = "PERPETUAL";
})(ContractType = exports.ContractType || (exports.ContractType = {}));
/**
 * 合约状态枚举
 * TRADING：交易中
 * OFFLINE：已下线
 */
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["TRADING"] = "TRADING";
    ContractStatus["OFFLINE"] = "OFFLINE";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
/** UI上的订单类型 */
var FuturesOrderTypeUI;
(function (FuturesOrderTypeUI) {
    FuturesOrderTypeUI["limit"] = "limit";
    FuturesOrderTypeUI["market"] = "market";
    FuturesOrderTypeUI["trigger"] = "trigger";
})(FuturesOrderTypeUI = exports.FuturesOrderTypeUI || (exports.FuturesOrderTypeUI = {}));
/** UI上的开仓或者平仓模式 */
var UIOpenCloseMode;
(function (UIOpenCloseMode) {
    /**开仓模式 */
    UIOpenCloseMode["OPEN"] = "open";
    /**平仓模式 */
    UIOpenCloseMode["CLOSE"] = "close";
})(UIOpenCloseMode = exports.UIOpenCloseMode || (exports.UIOpenCloseMode = {}));
/** 订单类型（后端定义） */
var CustomOrderType;
(function (CustomOrderType) {
    /** 限价单 */
    CustomOrderType["LIMIT"] = "limit";
    /** 市价单 (现货) */
    CustomOrderType["MARKET"] = "market";
    /** 市价单 (合约)，进入撮合前转为IOC订单 */
    CustomOrderType["MARKET_QTY"] = "market_qty";
    /** 立刻成交剩余取消订单 */
    CustomOrderType["IOC"] = "ioc";
    /** 全部成交否则取消订单 */
    CustomOrderType["FOK"] = "fok";
    /** 仅挂单 */
    CustomOrderType["POST"] = "post";
    /**触发后平仓 */
    CustomOrderType["CLOSE"] = "close";
    /**市价单：MARKET_AMT（按额市价买卖，仅合约支持） */
    CustomOrderType["MARKET_AMT"] = "market_amt";
    /**零滑点的市价单，目前由条件单触发，不支持用户手动下单 */
    CustomOrderType["ATS"] = "ats";
    /** 未知类型 */
    CustomOrderType["UNKNOWN"] = "unknown";
})(CustomOrderType = exports.CustomOrderType || (exports.CustomOrderType = {}));
var OrderSourceType;
(function (OrderSourceType) {
    /**界面下单*/
    OrderSourceType["MANUAL"] = "MANUAL";
    /**通过API下单 */
    OrderSourceType["API"] = "OPENAPI";
    /**系统代理订单 */
    OrderSourceType["SYSTEM"] = "SYSTEM";
    /**条件触发的订单 */
    OrderSourceType["TRIGGER"] = "TRIGGER";
})(OrderSourceType = exports.OrderSourceType || (exports.OrderSourceType = {}));
/**
 * 条件单原始状态
 * */
var TriggerOrderState;
(function (TriggerOrderState) {
    /**等待中：WAITING（等待A订单部分或完全成交） */
    TriggerOrderState["WAITING"] = "WAITING";
    /**已提交：SUBMITTED */
    TriggerOrderState["SUBMITTED"] = "SUBMITTED";
    /**已取消：CANCELED（终态） */
    TriggerOrderState["CANCELED"] = "CANCELED";
    /**已拒绝：REJECTED（终态，如：执行下单后被风控拒绝） */
    TriggerOrderState["REJECTED"] = "REJECTED";
    /**已触发：TRIGGERED（终态） */
    TriggerOrderState["TRIGGERED"] = "TRIGGERED";
})(TriggerOrderState = exports.TriggerOrderState || (exports.TriggerOrderState = {}));
/**全仓/逐仓模式 */
var FutureMarginType;
(function (FutureMarginType) {
    /**
     * 全仓模式
     */
    FutureMarginType["CROSS"] = "CROSS";
    /**
     * 逐仓模式
     */
    FutureMarginType["ISOLATED"] = "ISOLATED";
    /**
     * 分仓模式
     */
    FutureMarginType["COMPLETELY_ISOLATED"] = "COMPLETELY_ISOLATED";
})(FutureMarginType = exports.FutureMarginType || (exports.FutureMarginType = {}));
/**订单跟仓位的全仓/逐仓模式 */
var FutureOrderMarginType;
(function (FutureOrderMarginType) {
    FutureOrderMarginType["CROSS"] = "CROSS";
    /**逐仓双向：ISOLATED_BOTH */
    FutureOrderMarginType["ISOLATED_BOTH"] = "ISOLATED_BOTH";
    /**逐仓做多：ISOLATED_LONG */
    FutureOrderMarginType["ISOLATED_LONG"] = "ISOLATED_LONG";
    /**逐仓做空：ISOLATED_SHORT */
    FutureOrderMarginType["ISOLATED_SHORT"] = "ISOLATED_SHORT";
})(FutureOrderMarginType = exports.FutureOrderMarginType || (exports.FutureOrderMarginType = {}));
var FutureTimeInForce;
(function (FutureTimeInForce) {
    /**
     * 成交为止
     */
    FutureTimeInForce["GTC"] = "GTC";
    /**
     * 无法立即成交(吃单)的部分就撤销
     */
    FutureTimeInForce["IOC"] = "IOC";
    /**
     * 无法全部立即成交就撤销
     */
    FutureTimeInForce["FOK"] = "FOK";
    /**
     * 无法成为挂单方就撤销
     */
    FutureTimeInForce["GTX"] = "GTX";
})(FutureTimeInForce = exports.FutureTimeInForce || (exports.FutureTimeInForce = {}));
var FutureMarginAction;
(function (FutureMarginAction) {
    /**
     * 增加保证金
     */
    FutureMarginAction["asc"] = "asc";
    /**
     * 提取保证金
     */
    FutureMarginAction["desc"] = "desc";
})(FutureMarginAction = exports.FutureMarginAction || (exports.FutureMarginAction = {}));
/**
 *
 * buy  不reduce    both buy    买入
 * sell   不reduce   both sell    卖出
 * buy  reduce      short buy    平空
 * sell   reduce       long sell     平多
 */
var FuturePositionSide;
(function (FuturePositionSide) {
    /**
     * 既可以影响多仓又可以影响空仓（默认)
     */
    FuturePositionSide["BOTH"] = "both";
    /**
     * 仅可影响多仓 ( sell long 就是平多, 也就是reduce only 多仓 )
     */
    FuturePositionSide["LONG"] = "long";
    /**
     * 仅可影响空仓 ( buy short 就是平空, 也就是reduce only 空仓 )
     */
    FuturePositionSide["SHORT"] = "short";
})(FuturePositionSide = exports.FuturePositionSide || (exports.FuturePositionSide = {}));
var FutureWorkingType;
(function (FutureWorkingType) {
    /**
     * 标记价格
     */
    FutureWorkingType["MARK_PRICE"] = "MARK_PRICE";
    /**
     * 合约最新价 (默认)
     */
    FutureWorkingType["CONTRACT_PRICE"] = "CONTRACT_PRICE";
})(FutureWorkingType = exports.FutureWorkingType || (exports.FutureWorkingType = {}));
var InvestSymbolSide;
(function (InvestSymbolSide) {
    /** 按数量 */
    InvestSymbolSide["base"] = "base";
    /** 按价值 */
    InvestSymbolSide["quote"] = "quote";
    /** 按本金 */
    InvestSymbolSide["cost"] = "cost";
})(InvestSymbolSide = exports.InvestSymbolSide || (exports.InvestSymbolSide = {}));
/**订单查询的方向 */
var OrderDirect;
(function (OrderDirect) {
    /** 大于orderId的邻近订单（升序排列）：NEXT */
    OrderDirect["NEXT"] = "NEXT";
    /** 小于orderId的邻近订单（降序排列）：PREV */
    OrderDirect["PREV"] = "PREV";
})(OrderDirect = exports.OrderDirect || (exports.OrderDirect = {}));
/** 订单原始状态 */
var OrderState;
(function (OrderState) {
    /** 已提交 */
    OrderState["SUBMITTED"] = "SUBMITTED";
    /** 已确认 */
    OrderState["CONFIRMED"] = "CONFIRMED";
    /** 部分成交 */
    OrderState["PARTIAL_FILLED"] = "PARTIAL_FILLED";
    /** 成交完成 */
    OrderState["FILLED"] = "FILLED";
    /**  已取消 */
    OrderState["CANCELED"] = "CANCELED";
    /** 已拒绝：REJECTED（终态） */
    OrderState["REJECTED"] = "REJECTED";
    /** 该状态仅用于查询 部分成交已撤销 */
    OrderState["PARTIAL_CANCELED"] = "PARTIAL_CANCELED";
})(OrderState = exports.OrderState || (exports.OrderState = {}));
/** 订单状态 */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["OPEN"] = "open";
    OrderStatus["CANCELED"] = "canceled";
    OrderStatus["CLOSE"] = "closed";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
/**
 * 查询订单状态
 */
var QueryOrderStatus;
(function (QueryOrderStatus) {
    /** 全部成交 */
    QueryOrderStatus["CLOSED"] = "closed";
    /** 全部撤销 */
    QueryOrderStatus["CANCELED"] = "canceled";
})(QueryOrderStatus = exports.QueryOrderStatus || (exports.QueryOrderStatus = {}));
var OrderPositionMode;
(function (OrderPositionMode) {
    /**买卖模式（单向模式） */
    OrderPositionMode["BUYSELL"] = "BUYSELL";
    /**开平模式（双向模式） */
    OrderPositionMode["OPENCLOSE"] = "OPENCLOSE";
})(OrderPositionMode = exports.OrderPositionMode || (exports.OrderPositionMode = {}));
var FutureOrderMode;
(function (FutureOrderMode) {
    /**用户发起-普通订单 */
    FutureOrderMode["NORMAL"] = "normal";
    /**系统生成-强平订单（盘内） */
    FutureOrderMode["LIQUIDATION"] = "liquidation";
    /**系统生成-自身多空对抵（盘外）*/
    FutureOrderMode["INNERMERGE"] = "innermerge";
    /**系统生成-强平队列多空对抵（盘外）*/
    FutureOrderMode["CROSSMERGE"] = "crossmerge";
    /**系统生成-系统接管（盘外）*/
    FutureOrderMode["TAKEOVER"] = "takeover";
    /**ats订单 */
    FutureOrderMode["ALTERNATIVE"] = "alternative";
    /**DELISTING：系统下架结算（盘外） */
    FutureOrderMode["DELISTING"] = "delisting";
})(FutureOrderMode = exports.FutureOrderMode || (exports.FutureOrderMode = {}));
var OrderChangedNotifyType;
(function (OrderChangedNotifyType) {
    /** 正常已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["complete"] = 1] = "complete";
    /** 成交量发生裁剪, 交易已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["qtyChangedComplete"] = 2] = "qtyChangedComplete";
    /** 成交量发生裁剪, 交易未完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["qtyChangedNotComplete"] = 3] = "qtyChangedNotComplete";
    /** 市价单被IOC, 部分成交, 交易已完成 */
    OrderChangedNotifyType[OrderChangedNotifyType["marketBeenIOCComplete"] = 4] = "marketBeenIOCComplete";
    /** 市价单被IOC, 没成交, 交易失败 */
    OrderChangedNotifyType[OrderChangedNotifyType["marketBeenIOCCancelled"] = 5] = "marketBeenIOCCancelled";
})(OrderChangedNotifyType = exports.OrderChangedNotifyType || (exports.OrderChangedNotifyType = {}));
// 合约开单验证状态是否正常，非报错
var FuturesRequestStatus;
(function (FuturesRequestStatus) {
    /** 正常 */
    FuturesRequestStatus["Normal"] = "Normal";
    /** 限价单买入价格对比当前价差过量 */
    FuturesRequestStatus["LimitPriceExceed"] = "LimitPriceExceed";
})(FuturesRequestStatus = exports.FuturesRequestStatus || (exports.FuturesRequestStatus = {}));
/** 资金流水类型 */
var FuturesCashflowType;
(function (FuturesCashflowType) {
    /** 资金划转 */
    FuturesCashflowType["TRANSFER"] = "TRANSFER";
    /** 交易手续费 */
    FuturesCashflowType["TRADING_FEE"] = "TRADING_FEE";
    /** 强平手续费 */
    FuturesCashflowType["LIQUIDATION_FEE"] = "LIQUIDATION_FEE";
    /** 资金费 */
    FuturesCashflowType["FUNDING_FEE"] = "FUNDING_FEE";
    /** 仓位结算 */
    FuturesCashflowType["POSITION_SETTLEMENT"] = "POSITION_SETTLEMENT";
    /** 回补 */
    FuturesCashflowType["REMEDY"] = "REMEDY";
    /** 体验金 */
    FuturesCashflowType["TRIAL_FUND"] = "TRIAL_FUND";
    /** 联合保证金兑换 */
    FuturesCashflowType["MARGIN_SWAP"] = "MARGIN_SWAP";
    /** 下架手续费 */
    FuturesCashflowType["DELISTING_FEE"] = "DELISTING_FEE";
})(FuturesCashflowType = exports.FuturesCashflowType || (exports.FuturesCashflowType = {}));
/** 资金流水子类型 */
var FuturesCashflowSubType;
(function (FuturesCashflowSubType) {
    /** 划入账户 */
    FuturesCashflowSubType["ACCOUNT_IN"] = "ACCOUNT_IN";
    /** 划出账户 */
    FuturesCashflowSubType["ACCOUNT_OUT"] = "ACCOUNT_OUT";
    /** 划入策略 */
    FuturesCashflowSubType["STRATEGY_IN"] = "STRATEGY_IN";
    /** 划出策略 */
    FuturesCashflowSubType["STRATEGY_OUT"] = "STRATEGY_OUT";
    /** 手动划入逐仓 */
    FuturesCashflowSubType["ISO_MANUAL_IN"] = "ISO_MANUAL_IN";
    /** 手动划出逐仓 */
    FuturesCashflowSubType["ISO_MANUAL_OUT"] = "ISO_MANUAL_OUT";
    /** 自动划入逐仓 */
    FuturesCashflowSubType["ISO_AUTO_IN"] = "ISO_AUTO_IN";
    /** 自动划出逐仓 */
    FuturesCashflowSubType["ISO_AUTO_OUT"] = "ISO_AUTO_OUT";
    /** 普通交易手续费 */
    FuturesCashflowSubType["TRADING"] = "TRADING";
    /** 下架手续费 */
    FuturesCashflowSubType["DELISTING"] = "DELISTING";
})(FuturesCashflowSubType = exports.FuturesCashflowSubType || (exports.FuturesCashflowSubType = {}));
/** 资产保证金模式 */
var AssetMarginMode;
(function (AssetMarginMode) {
    /** 单币种保证金 */
    AssetMarginMode["SINGLE"] = "SINGLE";
    /** 多币种联合保证金 */
    AssetMarginMode["MULTI"] = "MULTI";
})(AssetMarginMode = exports.AssetMarginMode || (exports.AssetMarginMode = {}));
